import m from "mithril";

import { Day, getDay } from "../lib/data";
import { dayToWord } from "../lib/date_helpers";
import { yearPath } from "../lib/routes";

type DayPageParams = {
  attrs: {
    year: string,
    day: string,
  },
};

export class DayPage {
  year: number;
  day: number;
  data: Day;

  constructor({ attrs }: DayPageParams) {
    localStorage.setItem(`${attrs.year}-${attrs.day}`, "✓");
    this.year = parseInt(attrs.year);
    this.day = parseInt(attrs.day);
    this.data = getDay(this.year, this.day);
  }

  view() {
    return(
      <>
        <h1 className="day-title">
          <a href={yearPath(this.year)}>{this.year}</a> - Day {dayToWord(this.day)}
        </h1>
        {this.data.text !== "" && <p>{this.data.text}</p>}
        <a className="frame" href={this.data.image}>
          <img src={this.data.image} />
        </a>
      </>
    );
  }
}
